import { render, staticRenderFns } from "./McFixedBottom.vue?vue&type=template&id=086cc8fd&scoped=true&"
import script from "./McFixedBottom.vue?vue&type=script&lang=js&"
export * from "./McFixedBottom.vue?vue&type=script&lang=js&"
import style0 from "./McFixedBottom.vue?vue&type=style&index=0&id=086cc8fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086cc8fd",
  null
  
)

export default component.exports